/*
 *  @providesModule InsufficientFundsModalStyle
 *  
 */

/* eslint-disable no-magic-numbers */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  StyleSheet,
} from 'react-native';

const {
  btnTextColorOne,
  btnTextColorTwo,
  fontRegular,
  fontSecondary,
  fontSizeH4,
  textColorSecondary,
  viewCornerRadiusPrimary,
  viewPrimaryColor,
} = SkillzStyle.fullStyles;

export const DEPOSIT_TILE_HEIGHT = Sizes.select({
  phone: 85,
  tablet: 105,
});

export default StyleSheet.create({

  activityBackground: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  activityIndicator: {
    margin: 10,
    flex: 1,
    alignSelf: 'center',
  },

  activityIndicatorContainer: {
    ...viewPrimaryColor,
    ...viewCornerRadiusPrimary,
    height: 50,
    width: 50,
    alignSelf: 'center',
  },

  backButtonText: {
    ...fontSecondary,
    ...fontSizeH4,
    ...btnTextColorTwo,
  },

  backgroundImage: {
    flexGrow: 1,
    paddingVertical: 0,
    marginVertical: 0,
    width: Sizes.getUIWidth(),
  },

  buttonArrayOutOfFunds: {
    flexDirection: 'row',
    marginBottom: 10,
    marginTop: 5,
  },

  buttonOutOfFunds: {
    width: 130,
    height: 35,
    margin: 10,
  },

  okButtonText: {
    ...fontSecondary,
    ...fontSizeH4,
    ...btnTextColorOne,
  },

  outOfFundsStoreIcon: {
    width: 79,
    height: 69,
    marginTop: 40,
    marginBottom: 22,
  }, 

  textOutOfFunds: {
    ...fontRegular,
    ...fontSizeH4,
    ...textColorSecondary,
  },

  labelContainer: {
    marginHorizontal: 24,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },

  textDepositToContinue: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 19,
    ...textColorSecondary,
  },

  buttonClose: {
    height: 35,
    width: 195,
    marginBottom: 24,
    alignSelf: 'center',
  },

  innerStoreContainer: {
    alignSelf: 'stretch',
    alignItems: 'center',
    ...Sizes.dynamic({
      phone: {
        marginHorizontal: 20,
        borderRadius: 4,
        marginBottom: 16,
        
      },
      tablet: {
        backgroundColor: 'transparent',
        marginHorizontal: 24,
        marginBottom: 20,
      },
    }),
  },

  outerStoreContainer: {
    alignItems: 'center',
    flexGrow: 1,
  },

});
